export const logoPartnerList = [
    require('assets/images/logo-footer/logo-agribank.png'),
    require('assets/images/logo-footer/logo_donga.png'),
    require('assets/images/logo-footer/logo-sacom.png'),
    require('assets/images/logo-footer/logo-techcom-2.png'),
    require('assets/images/logo-footer/logo-vietcombank.png'),
    require('assets/images/logo-footer/logo-vietin.png'),
    require('assets/images/logo-footer/logo-eximbank.png'),
];
